package pl.michal_cyran.brand_hub.subpages.tutoring.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minWidth
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.window
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseOut
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.css.unaryMinus
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.CardStyle
import pl.michal_cyran.brand_hub.components.sections.LightBackgroundSection
import pl.michal_cyran.brand_hub.components.widgets.MarkedText
import pl.michal_cyran.brand_hub.components.widgets.PrimaryButton
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun TutoringHero() {
    val cm = ColorMode.current.toSitePalette()

    var isVisible by remember { mutableStateOf(false) }
    LaunchedEffect(Unit) {
        window.requestAnimationFrame { }
        isVisible = true
    }

    SimpleGrid(
        numColumns = numColumns(1, md = 2),
        modifier = Modifier.gap(20.px)
    ) {
        Column(
            modifier = Modifier
                .minWidth(0.px)
                .opacity(if (isVisible) 1 else 0)
                .transform { translateX(if (isVisible) 0.px else (-40).px) }
                .transition(
                    Transition.of("opacity", 0.7.s, EaseOut, 0.ms),
                    Transition.of("transform", 0.7.s, EaseOut, 0.ms)
                ),
            verticalArrangement = Arrangement.spacedBy(
                16.px,
                Alignment.CenterVertically
            ),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            // Zmiana H1 pod kątem SEO lokalnego (Kraków / Ruczaj)
            H1 {
                Span {
                    Text("Korepetycje z ")
                    MarkedText("matematyki")
                    Text(" i ")
                    MarkedText("informatyki")
                    Text(" w Krakowie.")
                }
            }

            // Rozbudowa opisu z nasyceniem fraz kluczowych: "matura", "egzamin 8-klasisty", "Ruczaj"
            P {
                Text(
                    "Skuteczna pomoc w zrozumieniu matematyki i programowania. Oferuję profesjonalne przygotowanie do matury oraz egzaminu ósmoklasisty stacjonarnie na krakowskim Ruczaju lub w wygodnej formie online."
                )
            }
            PrimaryButton(
                text = "Skontaktuj się",
                path = "mailto:michalcyran77777@gmail.com?subject=Korepetycje",
                icon = { FaEnvelope() }
            )
        }

        Column(
            modifier = Modifier
                .overflow(Overflow.Hidden)
                .fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Box(
                modifier = Modifier
                    .borderRadius(5.cssRem)
                    .overflow(Overflow.Hidden)
                    .height(500.px)
                    .opacity(if (isVisible) 1 else 0)
                    .transform {
                        translateX(if (isVisible) 0.px else 40.px)
                        scale(if (isVisible) 1.0 else 0.95)
                    }
                    .transition(
                        Transition.of("opacity", 0.7.s, EaseOut, 100.ms),
                        Transition.of("transform", 0.7.s, EaseOut, 100.ms)
                    )
            ) {
                Image(
                    src = "un0.jpg",
                    modifier = Modifier
                        .height(500.px)
                        .minWidth(0.px)
                        .objectFit(ObjectFit.Cover)
                )
            }

            Column(
                modifier = CardStyle.toModifier()
                    .padding(1.cssRem)
                    .position(Position.Relative)
                    .bottom((1.5).cssRem)
                    .left((-3).cssRem)
                    .borderRadius(1.5.cssRem)
                    .maxWidth(240.px)
                    .backgroundColor(cm.cardBg)
                    .opacity(if (isVisible) 1 else 0)
                    .transform {
                        rotate(if (isVisible) (-5).deg else 10.deg)
                        scale(if (isVisible) 1.0 else 0.7)
                    }
                    .transition(
                        Transition.of("opacity", 0.5.s, EaseOut, 500.ms),
                        Transition.of("transform", 0.5.s, EaseOut, 500.ms)
                    )
            ) {
                H2(
                    Modifier
                        .color(cm.primary)
                        .padding(bottom = 0.px)
                        .margin(bottom = 0.px)
                        .toAttrs()
                ) {
                    Text("100%")
                }
                P(
                    Modifier.fontSize(0.8.cssRem).fontWeight(500).toAttrs()
                ) {
                    Text("Zdawalność matur moich uczniów w 2026 roku")
                }
            }
        }
    }
}